module.exports = __webpack_public_path__ + "static/media/strongher2_preview.3246ceb8.jpg";